/**
 * EV-312（2026-10-13 PM 判断: 時間は「時・分・秒」で表し、空の値は「-」）。
 *
 * 時・分・秒の文言（Client の remove_task.duration_value・detail.hours_minutes・detail.minutes_value、
 * common の ui.duration-hm・ui.duration-m）は、英語で i18next の入れ子
 * `$t(unit.hour, {"count": {{hours}} })` を使う（EV-307。_one・_other で単複を出し分ける）。
 * 値が undefined・NaN だと入れ子の中が JSON として読めず「 NaN }」のように崩れるため、
 * 値がすべて 0 以上の有限の数のときだけ文言に渡し、そうでなければ「-」を出す。
 */
export const EMPTY_DURATION = '-';

export const isDurationPart = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0;

export function durationText(
  t: (key: string, options?: Record<string, unknown>) => string,
  key: string,
  parts: Record<string, unknown>,
  options: Record<string, unknown> = {}
): string {
  if (!Object.values(parts).every(isDurationPart)) return EMPTY_DURATION;
  return t(key, { ...options, ...parts });
}
